module.exports = __webpack_public_path__ + "static/media/group_disabled.69ede117.svg";